/* eslint-disable jsx-a11y/label-has-associated-control */
import cx from 'classnames';
import _ from 'lodash';
import React, { useContext, useMemo } from 'react';
import { IconID } from '../icon';
import { getIconPathFromIconID } from '../icon/icon-utils';
import { Colors, Typography } from '../typography';
import { RadioContext } from './radio.context';
import styles from './radio.module.scss';
import { RadioGroup } from './radio-group';
export const Radio = ({ label, value, id, className, hideRadio, checked, disabled = false, disabledTooltipContent = '', hasError = false, hideLabel = false, imageUrl = '', name, isSideLabel = false, subTitle = '', ...restProps }) => {
    const labelClassNames = cx(styles.radioLabel, {
        [styles.radioDisabled]: disabled,
    }, {
        [styles.hasError]: hasError,
    });
    const contextValues = useContext(RadioContext);
    const values = useMemo(() => {
        let usedCheckedValue = checked;
        if (typeof usedCheckedValue !== 'boolean') {
            usedCheckedValue = contextValues.selectedValue === value;
        }
        let usedHideRadio = hideRadio;
        if (typeof usedHideRadio !== 'boolean') {
            usedHideRadio = contextValues.hideRadio;
        }
        return {
            className: cx(contextValues.itemClassName, className),
            checked: usedCheckedValue,
            hideRadio: usedHideRadio,
        };
    }, [contextValues, className, hideRadio, checked, value]);
    const wrapperClassNames = cx(styles.formRadio, values.className, labelClassNames, {
        [styles.hideRadioButton]: values.hideRadio,
        [styles.imageChecked]: values.hideRadio && values.checked,
        [styles.imageCheckedIconLabelTypeSelected]: values.hideRadio && values.checked && isSideLabel,
        [styles.imageCheckedIconLabelType]: values.hideRadio && !values.checked && isSideLabel,
    });
    const labelContentClassNames = cx(styles.radioContent, {
        [styles.flexRow]: isSideLabel,
    });
    const showLabel = cx({
        [styles.hideLabel]: hideLabel,
        [styles.labelSpace]: isSideLabel,
        [styles.selectedLabel]: isSideLabel && values.hideRadio && values.checked,
    });
    const ariaLabelAttribute = hideLabel && _.isString(label) ? { 'aria-label': label } : {};
    return (React.createElement("label", { id: id, className: wrapperClassNames, ...restProps },
        React.createElement("input", { type: "radio", className: styles.radio, disabled: disabled, value: value, checked: values.checked, onChange: _.noop, ...ariaLabelAttribute, name: name }),
        React.createElement("span", { className: styles.customRadio },
            React.createElement("svg", { className: styles.customRadioCircle },
                React.createElement("use", { xlinkHref: getIconPathFromIconID(IconID.CIRCLE) }))),
        React.createElement("div", { className: labelContentClassNames },
            imageUrl && (React.createElement("img", { src: imageUrl, alt: "", className: styles.radioImage })),
            React.createElement("div", null,
                React.createElement(Typography, { variant: "body-normal", className: showLabel, overrideTag: "span", color: disabled ? Colors.grayLight : Colors.base, tooltipConfig: {
                        dataTooltipContent: disabledTooltipContent,
                        disableTooltip: !disabled,
                    } }, label),
                !!(subTitle === null || subTitle === void 0 ? void 0 : subTitle.length) && (React.createElement("div", null,
                    React.createElement(Typography, { variant: "body-normal", className: cx(showLabel, styles.subTitle), overrideTag: "span", color: Colors.info },
                        "(",
                        subTitle,
                        ")")))))));
};
Radio.Group = RadioGroup;
//# sourceMappingURL=radio.js.map